import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "antd";

interface Props {
  text: string;
  maxWidth?: number;
  className?: string;
}

const EllipsisTooltipText: React.FC<Props> = ({
  text,
  maxWidth = 145,
  className,
}) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const ref = textRef.current;
    if (ref) {
      const isOverflowing = ref.scrollHeight > ref.offsetHeight || ref.scrollWidth > ref.offsetWidth;
      setShowTooltip(isOverflowing);
    }
  }, [text]);

  const appliedClassName = className?.includes('caption') ? className : 'product-name';
  const content = (
    <p
      ref={textRef}
      className={appliedClassName}
      style={{
        width: `${maxWidth}px`,
        marginBottom: "0",
      }}
    >
      {text}
      {/* <span className="tooltip-text">{text}</span> */}
    </p>
  );

  return showTooltip ? (
    <Tooltip rootClassName="tooltip-ProductName" title={text} mouseEnterDelay={0.5}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default EllipsisTooltipText;
